
export { default as pipe } from "./pipe.js"